<template lang="pug">
  div
    v-row
      v-col(cols="12", md="10", offset-md="1")
        CreateUpdatePet(:update='true', :id_pet='$route.params.id', :vets='vets', :owners='owners', :species='species')
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CreateUpdatePet from '@/components/pets/CreateUpdatePet.vue'

export default {
  components: {
    CreateUpdatePet,
  },
  async created() {
    if (!this.auth_token) {
      this.$router.push('/auth/login');
    }
  },
  computed: {
    ...mapGetters({
      choices: "selectChoices",
      inventory_tag: "inventories/inventoryTag",
      inventory_chip: "inventories/inventoryChip",
      inventory_collar: "inventories/inventoryCollar",
    }),
    ...mapState({
      user: (state) => state.auth.user,
      auth_token: (state) => state.auth.auth_token,
    }),
  },
}
</script>
